<template>
<div>

    <van-popup position="bottom" v-model="showMianze" @click-overlay='close' :duration=".1">
        <div class="fxtreaty">
            <h2>免责声明</h2>
            <div class="abmianze"><MianzeMini /></div>
            <div class="btmbtn" @click="close">确定</div>
        </div>
    </van-popup>

</div>
</template>

<script>
    import MianzeMini from './mianze_mini'
    // import {mapGetters} from "vuex";
    export default {
        name: "mianzepop",
        // computed: mapGetters(['showMianze']),
        // props:  ['showTreaty'],
        components: {
            MianzeMini
        },
        data() {
            return {
                showMianze: true
            }
        },
        methods: {
            close(){
                this.$store.commit('HIDE_MIANZE')
            }
        }
    }
</script>

<style scoped>
    .van-popup{background: none;}
</style>
